module.exports = __webpack_public_path__ + "static/media/videofx_collab-pro-300x300.0f9ec07f.jpg";